import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InvoicesDataProvider } from '../../../../../../shared/services/invoice/invoices-data-service/invoices.data.service';
import { MessageService } from '../../../../../../shared/services/helpers/message-service/message.service';
import { SPInvoicesOverviewRequest } from '../../invoice.model';

@Component({
	selector: 'copy-invoice-to-quickBooks',
	template: require('./copy-invoice-to-quickBooks.modal.html'),
	styles: [require('./copy-invoice-to-quickBooks.modal.scss')]
})
export class CopyInvoiceToQuickBooksModal {
	@Input('jobId') jobId: number;
	@Input('integrationSystemName') integrationSystemName: string;
	@Output('updateInvoices')
	updateInvoices: EventEmitter<SPInvoicesOverviewRequest> = new EventEmitter<
		SPInvoicesOverviewRequest
	>();

	btnDisabled = false;
	copyInvoiceToOtherSystemSpinner = false;
	importInvoicesSpinner = false;

	constructor(
		private invoiceDataService: InvoicesDataProvider,
		private messageService: MessageService
	) {}

	integrateInvoiceWithOtherSystem(integrateInvoiceWithOtherSystem: boolean) {
		this.btnDisabled = true;

		integrateInvoiceWithOtherSystem
			? (this.copyInvoiceToOtherSystemSpinner = true)
			: (this.importInvoicesSpinner = true);

		this.invoiceDataService
			.integrateInvoiceWithQbOrZero(this.jobId, integrateInvoiceWithOtherSystem)
			.finally(() => this.removeSpinnersAndDisabled())
			.subscribe(
				(data: SPInvoicesOverviewRequest) =>
					this.successIntegrateInvoiceWithOtherSystem(data),
				error => this.messageService.showDefaultErrorMessage(error)
			);
	}

	successIntegrateInvoiceWithOtherSystem(
		data: SPInvoicesOverviewRequest
	): void {
		this.messageService.showToaster('s_7', 'shootProof');
		this.updateInvoices.emit(data);
		this.dismiss();
	}

	removeSpinnersAndDisabled(): void {
		this.btnDisabled = false;
		this.copyInvoiceToOtherSystemSpinner = false;
		this.importInvoicesSpinner = false;
	}

	dismiss(): void {
		$('#copyInvoiceToQBConfirmationModal').modal('hide');
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/invoices/modals/copy-invoice-to-quickBooks/copy-invoice-to-quickBooks.modal.ts